export class AccountRoutes
{
    static Home: string = `/`;
    static Login: string = `/login`;
    static Logout: string = `/logout`;
    static Register: string = `/register`;

    // OAuth
    static GithubOauthCallback: string = `/github/oauth/callback`;

    // Password
    static PasswordChange: string = `/password/change`;
    static PasswordForget: string = `/password/forget`;
    static PasswordNew: string = `/password/new/:user_id/:hash`;

    // Verify
    static VerifyPhone: string = `/phone/verify`;
    static VerifyEmail: string = `/email/verify`;

    // Notification
    static Notification: string = "/setting/notification"

    // User
    static UserProfile: string = `/user/profile`;
    static UserDelete: string = `/user/delete`;
    static UserBanned: string = `/user/banned`;
    static UserViewDecide(id: string)
    {
        return `/user/${id}/view/decide`;
    }
    static UserView(id: string)
    {
        return `/user/${id}/view`;
    }

    // Session
    static SessionList: string = `/session/list`;
    static SessionViewDecide(id: string)
    {
        return `/session/${id}/view/decide`;
    }
    static SessionView(id: string)
    {
        return `/session/${id}/view`;
    }
    static SessionSign(id: string)
    {
        return `/session/${id}/sign`;
    }

    // Service User
    static ServiceUserList: string = `/service/user/list`;
    static ServiceUserNew: string = `/service/user/new`;
    static ServiceUserCopy(id: string)
    {
        return `/service/user/${id}/new`;
    }
    static ServiceUserEdit(id: string)
    {
        return `/service/user/${id}/edit`;
    }
    static ServiceUserView(id: string)
    {
        return `/service/user/${id}/view`;
    }
    // Service Session
    static ServiceSessionList: string = `/service/session/list`;
    static ServiceSessionNew: string = `/service/session/new`;
    static ServiceSessionCopy(id: string)
    {
        return `/service/session/${id}/new`;
    }
    static ServiceSessionEdit(id: string)
    {
        return `/service/session/${id}/edit`;
    }
    static ServiceSessionView(id: string)
    {
        return `/service/session/${id}/view`;
    }
    static ServiceSessionSign(id: string)
    {
        return `/service/session/${id}/sign`;
    }
}